import { Box, Grid, styled, Typography } from '@mui/material';
import { ComponentProps } from 'react';

export const StyledContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  [theme.breakpoints.up('desktop')]: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'baseline',
    gap: theme.spacing(3),
  },
}));

export const StyledLoadingContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  height: theme.spacing(20),
  justifyContent: 'center',
  alignItems: 'center',
}));

export const StyledSubtext = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[300],
  marginBottom: theme.spacing(2),
}));

export const StyledGridItemBase = styled(Grid)<{ itemOrder: number }>(
  ({ theme, itemOrder }) => ({
    marginTop: theme.spacing(4),
    [theme.breakpoints.down('sm')]: {
      order: itemOrder,
    },
  })
);

export const StyledGridItem = (
  props: ComponentProps<typeof StyledGridItemBase>
) => <StyledGridItemBase item xl={6} lg={6} md={6} xs={12} {...props} />;
